import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Wachtwoord opnieuw instellen", -1)
const _hoisted_2 = { class: "content-box" }

import {ref} from "vue";
	import {FetchToken} from "../utils/FetchData";
	import emitter from '../main';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'ForgotPasswordPage',
  setup(__props) {

	const email = ref('');

	async function submit() {
		const body = new URLSearchParams({
			email: email.value
		});

		const data = await FetchToken('forgot-password', body);
		if(!data.isError) {
			console.log(data);
			emitter.emit('showMessage', {message: 'Email is verstuurd', header: 'Gelukt'});
			return;
		}
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: "Email",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event))
      }, null, 512), [
        [_vModelText, email.value]
      ])
    ]),
    _createElementVNode("button", {
      class: "content-box",
      onClick: submit
    }, " Email sturen ")
  ], 64))
}
}

})